/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { queryString } from '@utils/format';
let $ajax;

export const state = {
  refleksi: {},
  visitasi: {},
};

export const mutations = {
  SET_REFLEKSI(state, newValue) {
    state.refleksi = newValue;
  },
  SET_VISITASI(state, newValue) {
    state.visitasi = newValue;
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;

    return await http.get(`/psp/i/${id}/pendampingan-lingkup?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getDetail({ rootState, commit }, payloads) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lingkup`,
    });

    commit('SET_REFLEKSI', {});
    commit('SET_VISITASI', {});

    return await $ajax.get(`/${payloads.id}`);
  },

  async getDetailSekolah({ rootState, commit }, payloads) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lingkup/${payloads.id}`,
    });

    const detail = await $ajax.get(`/${payloads.type}`);
    commit(`SET_${payloads.type.toUpperCase()}`, detail);

    return detail;
  },

  async getDetailLaporan({ rootState, commit }, payloads) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/pendampingan-lingkup/${payloads.id}/${payloads.type}`,
    });

    const detail = await $ajax.get(`/${payloads.sekolahId}`);
    commit(`SET_${payloads.type.toUpperCase()}`, detail);

    return detail;
  },
};
